import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from "./http.service";

@Injectable()
export class ViewService {

  private viewsUrl = HttpService.ENDPOINT + "/api/View/";

  constructor(private httpService: HttpService) { }

  getViewById(viewId: string): Observable<any> {
    return this.httpService.get(this.viewsUrl + viewId);
  }

  requestViewById(viewId: string, callback: (response: any) => void, fallback?: (error: Error) => void, isAsync: boolean = false): number {
    return this.httpService.scheduleRequest('get', this.viewsUrl + '?cod=' + viewId, callback, fallback, null, null, isAsync, null);
  }

  getViewForEditor(viewId: string): Observable<any> {
    return this.httpService.get(this.viewsUrl + '?cod=' + viewId + '&debug=true');
  }

}